// extracted by mini-css-extract-plugin
export default {"container_slider":"BlogSlickslider_container_slider__xOXaN"};